// firebase config
export const firebaseConfig = {
  apiKey: "AIzaSyAwcWLsraJn8iUzDsIixyMWD72V6YsozxQ",
  authDomain: "ecommerce-8d30a.firebaseapp.com",
  projectId: "ecommerce-8d30a",
  storageBucket: "ecommerce-8d30a.firebasestorage.app",
  messagingSenderId: "986108510819",
  appId: "1:986108510819:web:facd87073c1a4663016e56",
  measurementId: "G-29LRNND514"
    // apiKey: "",
    // authDomain: "",
    // projectId: "",
    // storageBucket: "",
    // messagingSenderId: "",
    // appId: "",
    // measurementId: ""
  };